<template>
  <v-container style="min-height: calc(100vh - 124px);">
    <v-row>
      <v-col cols="12" md="12">
        <v-tabs
          v-model="tabsurat"
          show-arrows>
          <v-tab href="#tab-acc-unit" class="text-capitalize">
            <v-badge
              color="red"
              inline
              :content="dataaccunit.length">
              <v-icon>mdi-text-box-check-outline</v-icon>
              ACC Unit
            </v-badge>
          </v-tab>
          <v-tab href="#tab-acc-dir" class="text-capitalize">
            <v-badge
              color="red"
              inline
              :content="dataaccdir.length">
              <v-icon>mdi-text-box-check-outline</v-icon>
              ACC Direktur
            </v-badge>
          </v-tab>
        </v-tabs>
        <v-tabs-items :touchless="true" v-model="tabsurat">
          <v-tab-item value="tab-acc-unit">
            <v-card flat>
              <v-row justify="center" class="mt-3">
                <v-col cols="5">
                  <v-select
                    :items="liststatusacc"
                    name="statussurat"
                    item-text="label"
                    item-value="value"
                    v-model="filterunit.status"
                    label="Status"
                    @change="getAccUnitFilter">
                  </v-select>
                </v-col>
                <v-col cols="7">
                  <v-text-field
                    v-model="filterunit.search"
                    append-icon="search"
                    label="Search"
                    @input="getAccUnitFilter"
                    single-line
                    hide-details>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="12" class="mt-0" v-if="dataaccunit.length > 0">
                  <v-card
                    flat
                    v-for="(item, i) in dataaccunit"
                    :key="i"
                    :to="{ name: 'SKUnitDetail', params: { kodesurat: item.kd_sk }}">
                    <v-card-text>
                      <div class="text-subtitle-1 font-weight-black">
                        {{ item.kd_sk }}
                      </div>
                      <div class="text-subtitle-2">
                        {{ item.nama_hal }}
                      </div>
                      <div class="caption">
                        by.<b>{{ item.user_sk }}</b>, at.<b>{{ item.tgl_ajukan }}</b>
                      </div>
                      <div class="text-subtitle-2 font-weight-bold mt-2">
                        {{ item.judul_sk }}
                      </div>
                      <v-chip
                        class="my-2"
                        :color="item.status_sk == 'siap' ? 'green' : 'red'"
                        text-color="white"
                        small>
                        {{ item.status_sk }}
                      </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>
                  </v-card>
                </v-col>
                <v-col cols="12" class="mt-0" v-if="dataaccunit.length <= 0">
                  Tidak ada list permohonan!
                </v-col>
                <v-col cols="12">
                  <infinite-loading :identifier="infiniteId2" @infinite="getAccUnit">
                    <div slot="spinner">Loading...</div>
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                  </infinite-loading>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-acc-dir">
            <v-card flat>
              <v-row justify="center" class="mt-3">
                <v-col cols="5">
                  <v-select
                    :items="liststatusdir"
                    name="statussurat"
                    item-text="label"
                    item-value="value"
                    v-model="filterdir.status"
                    label="Status"
                    @change="getAccDirFilter">
                  </v-select>
                </v-col>
                <v-col cols="7">
                  <v-text-field
                    v-model="filterdir.search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    @input="getAccDirFilter">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mt-0" v-if="dataaccdir.length > 0">
                  <v-card
                    flat
                    v-for="(item, i) in dataaccdir"
                    :key="i">
                    <v-card-text>
                      <div class="d-flex align-center">
                        <RouterLink
                          class="text-decoration-none black--text"
                          :to="{ name: 'SKDirDetail', params: { kodesurat: item.kd_sk }}">
                          <div class="text-subtitle-1 font-weight-black">
                            {{ item.kd_sk }}
                          </div>
                          <div class="text-subtitle-2">
                            {{ item.nama_hal }}
                          </div>
                          <div class="caption">
                            by.<b>{{ item.user_sk }}</b>, at.<b>{{ item.tgl_ajukan }}</b>
                          </div>
                          <div class="text-subtitle-2 font-weight-bold mt-2">
                            {{ item.judul_sk }}
                          </div>
                          <v-chip
                            class="my-2"
                            :color="item.status_sk == 'siap' ? 'green' : 'red'"
                            text-color="white"
                            small>
                            {{ item.status_sk }}
                          </v-chip>
                        </RouterLink>
                        <div class="ml-auto">
                          <v-checkbox
                            v-if="item.status_sk === 'proses'"
                            v-model="selectdirbulk"
                            :value="item.kd_sk">
                          </v-checkbox>
                          <v-icon
                            v-if="item.status_sk === 'siap'"
                            color="green">
                            mdi-check-circle
                          </v-icon>
                          <v-icon
                            v-if="item.status_sk === 'tolak'"
                            color="red">
                            mdi-close-circle
                          </v-icon>
                        </div>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                  </v-card>
                </v-col>
                <v-col cols="12" class="mt-0" v-if="dataaccdir.length <= 0">
                  Tidak ada list permohonan!
                </v-col>
                <v-col cols="12">
                  <infinite-loading :identifier="infiniteId" @infinite="getAccDir">
                    <div slot="spinner">Loading...</div>
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                  </infinite-loading>
                </v-col>
              </v-row>
            </v-card>
            <v-fab-transition>
              <v-btn
                v-if="selectdirbulk.length > 0"
                color="success"
                dark
                bottom
                right
                fixed
                @click="submitBulkDir"
                :loading="loading.bulksurat"
                :disabled="loading.bulksurat || selectdirbulk.length <= 0"
                depressed
                class="mb-12 text-capitalize">
                Bulk proses
              </v-btn>
            </v-fab-transition>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'SKDosen',
  data: () => ({
    selectedItem: 1,
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    notifbulk: {
      title: 'Info',
      type: 'warn',
      text: '',
    },
    loading: {
      check: false,
      changest: false,
      bulksurat: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    dataaccunit: [],
    dataaccdir: [],
    listcategory: ['job-fair', 'motivation'],
    liststatusacc: [
      {
        value: 'permohonan',
        label: 'Perlu Acc',
      },
      {
        value: 'history',
        label: 'History Acc',
      },
      {
        value: 'semua',
        label: 'Semua',
      },
    ],
    liststatusdir: [
      {
        value: 'proses',
        label: 'Perlu Acc',
      },
      {
        value: 'history',
        label: 'History Acc',
      },
      {
        value: 'semua',
        label: 'Semua',
      },
    ],
    filterunit: {
      search: '',
      status: 'permohonan',
      limit: 10,
      offset: 0,
    },
    filterdir: {
      search: '',
      status: 'proses',
      limit: 10,
      offset: 0,
    },
    panduan: null,
    paramkamus: {
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
    infiniteId2: +new Date(),
    wdayshow: true,
    tabsurat: null,
    selectdirbulk: [],
  }),
  mounted() {
    // this.getKamus();
    if (this.$route.query.tab && this.$route.query.tab !== '') {
      this.tabsurat = this.$route.query.tab;
    }
    // update title
    this.$store.commit('UPDATE_TITLE', 'Surat Keputusan');
    // get data
    // this.getAccUnit();
    // this.getAccDir();
    // check woday
    // this.checkWday();
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'wday',
    ]),
  },
  methods: {
    getAccUnitFilter() {
      this.filterunit.offset = 0;
      this.dataaccunit = [];
      this.infiniteId2 += 1;
    },
    getAccDirFilter() {
      this.filterdir.offset = 0;
      this.dataaccdir = [];
      this.infiniteId += 1;
    },
    submitBulkDir() {
      this.notifbulk.title = 'Bulk proses status:';
      // console.log(this.selectdirbulk);
      if (this.tokenscr) {
        this.loading.bulksurat = true;
        // request
        this.axios
          .post(
            this.api + '/api/sk/bulkaccdir',
            qs.stringify(
              { listkd : this.selectdirbulk },
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.notifbulk.type = 'success';
                this.notifbulk.text = '"' + this.selectdirbulk.length + '" data di proses, "' + resdata.data.sucess + '" data sukses, "' + resdata.data.error + '" data gagal!';
                this.selectdirbulk = [];
                this.getAccDirFilter();
              } else {
                this.notifbulk.type = 'error';
                this.notifbulk.text = resdata.message;
              }
            } else {
              this.notifbulk.type = 'error';
              this.notifbulk.text = 'Internal services error!';
            }
            this.loading.bulksurat = false;
            this.$notify(this.notifbulk);
          })
          .catch((error) => {
            this.notifbulk.type = 'error';
            this.notifbulk.text = 'Internal services error!';
            this.loading.bulksurat = false;
            this.$notify(this.notifbulk);
          });
      } else {
        this.notifbulk.type = 'error';
        this.notifbulk.text = 'Invalid token!';
        this.$notify(this.notifbulk);
      }
    },
    getAccUnit($state) {
      if (this.tokenscr) {
        // this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/sk/accunit',
            {
              params: this.filterunit,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // this.dataaccunit = resdata.data;
                if (resdata.data.length > 0) {
                  this.filterunit.offset += this.filterunit.limit;
                  this.dataaccunit.push(...resdata.data);
                  if (this.dataaccunit.length < this.filterunit.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changest = false;
          });
      }
    },
    getAccDir($state) {
      if (this.tokenscr) {
        // this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/sk/accdir',
            {
              params: this.filterdir,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // this.dataaccdir = resdata.data;
                if (resdata.data.length > 0) {
                  this.filterdir.offset += this.filterdir.limit;
                  this.dataaccdir.push(...resdata.data);
                  if (this.dataaccdir.length < this.filterdir.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.changest = false;
          });
      }
    },
    checkWday() {
      const now = new Date();
      const datenow = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
      if (this.wday) {
        const wdaytgl = this.wday.date ? this.wday.date : '';
        // console.log(wdaytgl);
        if (datenow !== wdaytgl) {
          // get data
          this.getWorday(datenow);
        }
      } else {
        // get data
        this.getWorday(datenow);
      }
    },
    getWorday(datenow) {
      this.axios
        .get(
          this.api + '/public/wordday',
          {
            params: {},
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                const rdata = resdata.data[0];
                const pdata = {
                  id_vocab: rdata.id_vocab,
                  vocab_en: rdata.vocab_en,
                  part_of: rdata.part_of,
                  date: datenow,
                };
                this.$store.commit('UPDATE_WDAY', pdata);
                this.wdayshow = true;
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getKamusFilter() {
      this.paramkamus.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getKamus($state) {
      this.axios
        .get(
          this.api + '/public/kamus',
          {
            params: this.paramkamus,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramkamus.offset += this.paramkamus.limit;
                this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramkamus.offset) {
                  if ($state !== false) {
                    $state.complete();
                  }
                } else {
                  if ($state !== false) {
                    $state.loaded();
                  }
                }
              } else {
                if ($state !== false) {
                  $state.complete();
                }
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $main-color: #216185;

  .item-list-style{
    border-bottom: solid thin #BDBDBD;
  }
  .item-list-style:hover{
    color: $main-color;
    border-color: $main-color;
  }
  a.link-list-style{
    text-decoration: none;
    color: black;
  }
</style>
